import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestModelResponse, UpdateModelRequestDTO } from "@/types";

async function updateModel(
  request: UpdateModelRequestDTO
): Promise<RequestModelResponse> {
  const { id, ...updateData } = request;
  const response = await httpRequest.put<RequestModelResponse>(
    `/models/${id}`,
    updateData
  );
  return response.data;
}

export function useUpdateModelMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateModel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["models"] });
    },
  });
}
